import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { imagesLinks } from "../Constants/links";
import { FooterSection } from "../Components/LauncherPageComponent/launcherPageComponent";
import SDK from "../config";
import "../Components/styles/launcherPageComponent.css";

const ReservationPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const navigate = useNavigate();

  const clickCountMeIn = () => {
    navigate(`/payment-checkout?email=${encodeURIComponent(email)}`);
  };

  // Check if the current route is '/reservation'
  const isReservationRoute = location.pathname === "/reservation";

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 829);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 829);
    };

    // Initial check when the component mounts
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Fragment>
      <div style={{ overflow: "hidden" }}>
        <div className="reservation_page">
          <div className="text_part">
            <div className="reservation_logo">
              <div>
                <img
                  src={imagesLinks.logo}
                  className="navLogo"
                  style={{
                    paintOrder: "stroke fill",
                    fill: "black",
                    WebkitTextStroke: "12px black",
                  }}
                  alt=""
                />
              </div>
            </div>

            <div className="text_box">
              <p className="pa1">
                Welcome! Get Android lifetime access for ${SDK.FB_PRICE} USD
                one-time payment
              </p>
              <p className="pa2">Limited time only.</p>
              <p className="pa3">
                We currently charge $49 yearly on the Google Play store. But
                today’s your lucky day!
              </p>
              <p className="pa3">
                That's less than 1/6 the price of a dumbphone, without
                sacrificing the utility of your smartphone or needlessly
                polluting the environment.
              </p>
              <button onClick={clickCountMeIn}>Get lifetime access</button>
            </div>
          </div>
          <div
            className={`cards_part ${
              isReservationRoute ? "reservation-specific" : ""
            }`}
          >
            <div className="img_text_box">
              <div className="card-img-text-box">
                <div className="card-img-area">
                  <img src={imagesLinks.minimisTeam} alt="" />
                </div>
              </div>
              <div
                className={`reservation_crad_box ${
                  isReservationRoute ? "reservation_page_box" : ""
                }`}
              >
                <div className="card1">
                  <div className="card_icon">
                    <img src={imagesLinks.c1} alt="" />
                  </div>
                  <div className="card_text">
                    <p className="card_p1">
                      Lock in a massive lifetime discount
                    </p>
                    <p className="card_p2">
                      Exclusive pricing available for a limited time only!
                    </p>
                  </div>
                </div>
                <div className="card1 card-bottom">
                  <div className="card_icon">
                    <img src={imagesLinks.c3} alt="" />
                  </div>
                  <div className="card_text">
                    <p className="card_p1">Payment secured by Stripe</p>
                    <p className="card_p2">
                      The same payment processor Apple, Amazon, Etsy, Walmart &
                      Target use. No credit card details seen or stored by us!
                    </p>
                  </div>
                </div>
                {/* Move the footer_section here if screen width is less than 830px */}
                {isMobileView && (
                  <div className="footer_section">
                    <FooterSection />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Render the footer_section normally if screen width is greater than 830px */}
        </div>
        {!isMobileView && (
          <div className="footer_section">
            <FooterSection />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ReservationPage;
